__turbopack_context__.v({
  "bar": "gCxaFq_bar",
  "legend": "gCxaFq_legend",
  "legendDot": "gCxaFq_legendDot",
  "legendItem": "gCxaFq_legendItem",
  "segment": "gCxaFq_segment",
  "variantBlack": "gCxaFq_variantBlack",
  "variantBlue": "gCxaFq_variantBlue",
  "variantGreen": "gCxaFq_variantGreen",
  "variantRed": "gCxaFq_variantRed",
});
